import { IGesundheitsProgrammInfo } from '../mgs.types';
import { htmlOut } from '@mng/mng-ts-helpers';

export const GESUNDHEITS_PROGRAMM_KLASSIK_HOTEL_ID = 200;
export const GESUNDHEITS_PROGRAMM_KLASSIK_MED_CHECK_MYHEART_ID = 220;
export const GESUNDHEITS_PROGRAMM_KLASSIK_MED_CHECK_MYBACK_ID = 230;
export const GESUNDHEITS_PROGRAMM_KLASSIK_MED_CHECK_MYMIND_ID = 240;

export const GESUNDHEITS_PROGRAMM_KIDS_ID = 1000;

export const GESUNDHEITS_PROGRAMM_KIDS_TEENS_ID = 1003;

export const GESUNDHEITS_PROGRAMM_BALANCE_ID = 310;

export const GESUNDHEITS_PROGRAMM_ENERGIE_ID = 320;

export const GESUNDHEITS_PROGRAMM_AYURVEDA_ID = 330;
export const GESUNDHEITS_PROGRAMM_AESTHETIK_ID = 380;

export const GESUNDHEITS_PROGRAMM_SOUL_ID = 311;
export const GESUNDHEITS_PROGRAMM_FERNOST_ID = 400;

export const GESUNDHEITS_PROGRAMM_RELAX_ID = 360;

export const GESUNDHEITS_PROGRAMM_LEHRER_HARMONIE_ID = 5001;

export const GESUNDHEITS_PROGRAMM_LEHRER_SPORT_ID = 5002;

export const GESUNDHEITS_PROGRAMM_LEHRER_DYNAMIK_ID = 5003;

export const GESUNDHEITS_PROGRAMM_LEHRER_RELAX_ID = 5004;

export const GESUNDHEITS_PROGRAMM_FITNESS_TRAINER1_ID = 500;

export const GESUNDHEITS_PROGRAMM_FITNESS_TRAINER2_ID = 501;

export const GESUNDHEITS_PROGRAMM_FITNESS_TEENS_TRAINER1_ID = 800;

export const GESUNDHEITS_PROGRAMM_FITNESS_TEENS_TRAINER2_ID = 802;

export const GESUNDHEITS_PROGRAMM_FITNESS_OPT_TEENS_TRAINER_LIGHT_ID = 801;

export const GESUNDHEITS_PROGRAMM_FITNESS_OPT_TEENS_TRAINER_LIGHT2_ID = 803;

export const GESUNDHEITS_PROGRAMM_FITNESS_AKTIV_FITNESS_LIGHT_ID = 1100;

export const GESUNDHEITS_PROGRAMM_FITNESS_AKTIV_FITNESS_LIGHT2_ID = 1110;

export const GESUNDHEITS_PROGRAMM_FITNESS_OPT_AKTIV_FITNESS_LIGHT_ID = 1101;

export const GESUNDHEITS_PROGRAMM_MINI_ID = 1400;

export const GESUNDHEITS_PROGRAMM_ERNAEHRUNG_MED_CHECK_ID = 2500;

export const GESUNDHEITS_PROGRAMM_ERNAEHRUNG_TEENS_MED_CHECK_ID = 3000;

export const GESUNDHEITS_PROGRAMM_ERNAEHRUNG_OPT_CHECK_LIGHT_ID = 2502;

export const GESUNDHEITS_PROGRAMM_ERNAEHRUNG_MED_CHECK_LIGHT_ID = 2501;

export const GESUNDHEITS_PROGRAMM_TIME4ME_1WOCHE_ID = 9000;

export const GESUNDHEITS_PROGRAMM_TIME4ME_2WOCHEN_ID = 9001;

export const GESUNDHEITS_PROGRAMM_DETOX_ID = 340;

export const GESUNDHEITS_PROGRAMM_SPECIALS_ALLGEMEIN = 350; // auslaufendes
// "allgemeines"
// Specials

export const GESUNDHEITS_PROGRAMM_SPECIAL_YOGA_RETREAT = 351;

export const GESUNDHEITS_PROGRAMM_SPECIAL_NATURE_RETREAT = 352;

export const GESUNDHEITS_PROGRAMM_SPECIAL_BIKE = 354;
export const GESUNDHEITS_PROGRAMM_SPECIAL_DETOX = 356;

export const GESUNDHEITS_PROGRAMM_NUTRITION_ID = 550;
export const GESUNDHEITS_PROGRAMM_NUTRIGENETIK_ID = 353;

export const GESUNDHEITS_PROGRAMM_NUTRIGENETIK_COACHING_ID = 355;

export const GESUNDHEITS_PROGRAMM_BODY_ID = 1200;

export const GESUNDHEITS_PROGRAMM_CARDIO_FIT_ID = 1201;

export const GESUNDHEITS_PROGRAMM_RUECKEN_FIT_ID = 1202;

export const GESUNDHEITS_PROGRAMM_HIGHTECH_FRUEHERKENNUNG_ID = 11000;

export const GESUNDHEITS_PROGRAMM_HIGHTECH_FRUEHERKENNUNG_2_JAEHRIG_ID = 11001;

export const GESUNDHEITS_PROGRAMM_PHARMAKOGENETIK_ID = 11002;

export const GESUNDHEITS_PROGRAMM_INSTAHELP_ID = 370;

export const GESUNDHEITS_PROGRAMM_MED_MENTAL_ID = 210;

export const GESUNDHEITS_PROGRAMM_YOGA_ID = 1600;
export const GESUNDHEITS_PROGRAMM_YOGA_JUNIORS_ID = 1601;
export const GESUNDHEITS_PROGRAMM_YOGA_LIGHT_ID = 1602;
export const GESUNDHEITS_PROGRAMM_YOGA_JUNIOR_LIGHT_ID = 1603;
export const GESUNDHEITS_PROGRAMM_WELLFEELING_ID = 8000;
export const GESUNDHEITS_PROGRAMM_WELLFEELING_LIGHT_ID = 8001;

// Programme die in der Demo Programm Ansicht angezeigt werden sollen
export const demoProgrammIds = [
  GESUNDHEITS_PROGRAMM_KLASSIK_HOTEL_ID,
  GESUNDHEITS_PROGRAMM_KLASSIK_MED_CHECK_MYHEART_ID,
  GESUNDHEITS_PROGRAMM_KLASSIK_MED_CHECK_MYBACK_ID,
  GESUNDHEITS_PROGRAMM_KLASSIK_MED_CHECK_MYMIND_ID,
  GESUNDHEITS_PROGRAMM_FERNOST_ID,
  GESUNDHEITS_PROGRAMM_MED_MENTAL_ID,
  GESUNDHEITS_PROGRAMM_AYURVEDA_ID,
  GESUNDHEITS_PROGRAMM_RELAX_ID,
  GESUNDHEITS_PROGRAMM_AESTHETIK_ID,
  GESUNDHEITS_PROGRAMM_CARDIO_FIT_ID,
  GESUNDHEITS_PROGRAMM_RUECKEN_FIT_ID,
  GESUNDHEITS_PROGRAMM_FITNESS_TRAINER1_ID,
  GESUNDHEITS_PROGRAMM_FITNESS_TRAINER2_ID,
  GESUNDHEITS_PROGRAMM_YOGA_ID,
  GESUNDHEITS_PROGRAMM_NUTRITION_ID,
  GESUNDHEITS_PROGRAMM_NUTRIGENETIK_ID,
  GESUNDHEITS_PROGRAMM_NUTRIGENETIK_COACHING_ID,
  GESUNDHEITS_PROGRAMM_MINI_ID,
  GESUNDHEITS_PROGRAMM_ERNAEHRUNG_MED_CHECK_ID,
  GESUNDHEITS_PROGRAMM_SPECIAL_YOGA_RETREAT,
  GESUNDHEITS_PROGRAMM_SPECIAL_BIKE,
  GESUNDHEITS_PROGRAMM_SPECIAL_DETOX,
  GESUNDHEITS_PROGRAMM_TIME4ME_1WOCHE_ID,
  GESUNDHEITS_PROGRAMM_HIGHTECH_FRUEHERKENNUNG_ID
];

export function isNotMaxPunkteAnzeigeRelevant(programmId: number) {
  return GESUNDHEITS_PROGRAMM_KLASSIK_HOTEL_ID === programmId;
}

export function isKidsPrgoramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_KIDS_ID === programmId || GESUNDHEITS_PROGRAMM_KIDS_TEENS_ID === programmId;
}

export function isAyurvedaPrgoramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_AYURVEDA_ID === programmId;
}

export function isRelaxPrgoramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_RELAX_ID === programmId;
}

export function isFitCardioPrgoramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_CARDIO_FIT_ID === programmId;
}

export function isBodyProgramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_BODY_ID === programmId;
}

export function isInstahelpProgramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_INSTAHELP_ID === programmId;
}

export function isPharmakogenetikProgramm(programmId: number): boolean {
  return GESUNDHEITS_PROGRAMM_PHARMAKOGENETIK_ID === programmId;
}

export function isApiAbschlussProgramm(programmId: number): boolean {
  return isInstahelpProgramm(programmId);
}

export function isFrueherkennungProgramm(programmId: number): boolean {
  return (
    GESUNDHEITS_PROGRAMM_HIGHTECH_FRUEHERKENNUNG_ID === programmId ||
    GESUNDHEITS_PROGRAMM_HIGHTECH_FRUEHERKENNUNG_2_JAEHRIG_ID === programmId
  );
}

export function hatFrueherkennungProgramm(programme: IGesundheitsProgrammInfo[]): boolean {
  return programme?.some((programm) => isFrueherkennungProgramm(programm.id));
}

export function programmInfoHtmlAsString(programm: IGesundheitsProgrammInfo, detail = false): string {
  return `<div style='min-width: 200px'>
          ${htmlOut('Programm', programm.label)}
          ${detail ? htmlOut('Programm Nummer', programm.id) : ''}
          </div>
`;
}
